/**
 * Date formatting that cannot throw out of a render.
 *
 * `new Date(undefined).toISOString()` raises RangeError, and thrown from render
 * that takes the component down — which is how a map popup lost its whole tree
 * over a photograph with no timestamp.
 */

/** The ISO string, or "" when there is no usable date. Never throws. */
export const isoOrEmpty = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
};

export default isoOrEmpty;
